export default __webpack_public_path__ + "static/worker-3739cfe20604e80c99229e341467fcb7.png";